import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'nbtips',
  template: require('./nbtips.component.html'),
  styles: [require('./nbtips.component.scss')]
})

export class NbtipsComponent {
  _description: string;
  isImage = false;
  @Input()
  set description(val: string) {
    if (val) {
      this._description = val;
      if (val.startsWith("http://") || val.startsWith("https://")) {
        this.isImage = true;
      }
    }
  }
  get description() {
    return this._description;
  }
  public constructor() {}
}
